import { mapSubdomainToCabinetType } from "../../shared/constants";

export function getApiUrl(suffix) {
  const cabinetType = getCabinetType();

  const mapCabinetTypeToURL = {
    dsp: process.env.DSP_BASE_API_URL,
    advert: process.env.ADVERT_BASE_API_URL,
    exchange: process.env.EXCHANGE_BASE_API_URL,
    webmaster: process.env.WEBMASTER_BASE_API_URL
  };

  return `//${mapCabinetTypeToURL[cabinetType]}${suffix || ""}`;
}

export const getCabinetType = () => {
  const match = window.location.hostname.match(/^[a-z-]+/gm);

  if (match) {
    const [subdomain] = match;

    return mapSubdomainToCabinetType[subdomain];
  }

  return "exchange";
};
